<template>
  <div class="rootDiv">
    <div id="map" :style="{'width':width+'px','height':height+'px'}"></div>
  </div>
</template>

<script>

import {Indicator} from "mint-ui";

export default {
  name: "BingMap",
  components: {},
  props: ['points'],
  data() {
    return {
      map: {},
      point: [],
      scale: 14,
      myWindow: window,
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
      getAllAirportUrl: '/api/airport/getAllAirport',
    }
  },
  methods: {
    test(lng, lat) {
      let that = this
      that.map.centerAndZoom(new that.myWindow.T.LngLat(lng, lat), 14);
    },
    loadAllAirport() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getAllAirportUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            let temp = response.data['responseData']
            let list = []
            temp.forEach(x => {
              let item = {title: x.jCMC, data: x}
              list.push(item)
            })
            that.point = list
            that.load()
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    load() {
      let that = this
      const init = new Promise((resolve, reject) => {
        if (typeof that.myWindow.T !== "undefined") {
          console.log('地图初始化成功')
          resolve(that.myWindow.T)
          reject('error')
        } else {
          console.log('地图初始化失败')
        }
      })
      init.then(T => {
        that.map = new T.Map('map');
        that.map.setMapType(that.myWindow.TMAP_HYBRID_MAP);
        that.map.centerAndZoom(new T.LngLat(
            that.point[0].data.jD,
            that.point[0].data.wD), that.scale);
        that.markerPoint()
      })
    },
    /**
     * 添加普通标注
     * @param site  (site.lng, site.lat)  地理坐标
     */
    markerPoint() {
      let that = this
      let bo = true
      if (that.point.length === 1)
        bo = false
      that.point.forEach(item => {
        //创建标注对象
        let marker = null
        if (bo) {
          let imageUrl
          if (item.data.dJ === '4F')
            imageUrl = 'level_4f.png'
          else if (item.data.dJ === '4E')
            imageUrl = 'level_4e.png'
          else if (item.data.dJ === '4D')
            imageUrl = 'level_4d.png'
          else if (item.data.dJ === '4C')
            imageUrl = 'level_4c.png'
          else
            imageUrl = 'level_other.png'
          let markerLngLat = new that.myWindow.T.LngLat(item.data.jD, item.data.wD) // 标注的经纬度
          let size = 40
          let uniqueCode = new Date().valueOf()
          let icon = new that.myWindow.T.Icon({ // 创建图片对象
            iconUrl: require('../../../../assets/images/128/' + imageUrl),
            iconSize: new that.myWindow.T.Point(size, size),
            iconAnchor: new that.myWindow.T.Point(size / 2, size),
            uniqueCode: uniqueCode
          })
          marker = new that.myWindow.T.Marker(markerLngLat, {icon: icon})
        } else {
          marker = new that.myWindow.T.Marker(new that.myWindow.T.LngLat(item.data.jD, item.data.wD))
        }

        //向地图上添加标注
        that.map.addOverLay(marker)
        let dj = item.data.dJ ? ('（' + item.data.dJ + '）') : ''
        let lng = item.data.jD
        let lat = item.data.wD
        let text_div = '<a href="javascript:test(\'' + lng + '\',\'' + lat + '\')" style="color: #2986de;font-size: 1.2rem">' + item.title + dj + '</a>'
        let content = '<div>' + text_div + '</div>'    //这里展示信息框的内容  ,也可以操作dom  但是dom中不能获取到后台数据,因为dom会比这里先加载完,数据没法赋值

        addClickHandler(content, marker)
        marker.content = content
      })

      function addClickHandler(content, marker) {
        marker.addEventListener('click', function (e) {
          openInfo(content, e)
        })
      }

      function openInfo(content, e) {
        let point = e.lnglat
        let markerInfoWin = new that.myWindow.T.InfoWindow(content, {
          offset: new that.myWindow.T.Point(0, -30)
        })
        that.map.openInfoWindow(markerInfoWin, point) // 开启信息窗口
      }
    },
  },
  mounted() {
    window.test = this.test
    /**let script = document.createElement('script')
     script.type = 'text/javascript'
     script.src = 'http://api.tianditu.gov.cn/api?v=4.0&tk=8e171fa6e41b4fdf3ca25fe03dc02660'
     document.body.appendChild(script)**/
    let that = this
    if (that.$route.query.point !== undefined) {
      that.$route.query.point.forEach(x => that.point.push(x))
      if (that.point.length === 1)
        that.scale = 14
      else {
        that.scale = 6
      }
      that.load()
    } else {
      that.scale = 4
      that.loadAllAirport()
    }
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin-left: -0.5rem;
  margin-top: -0.5rem;
}
</style>
